import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { RegexConfig } from '../../configs/config';
import { ACTION, } from './types';
import { ROUTE } from '../../routes';
import { isMobile, isPartnerAffiliated } from "../../configs/utils";
const _isMobile = isMobile();
export const PhoneNumberDS = (path, partnerName, partnerPhoneNumber, showEmailScreen, refCode, referredPartner, termsLink, privacyLink, partnerAccountType, showARNScreen) => {
    const DS = {
        signupComponentContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            minWidth: _isMobile ? '95%' : 450,
            maxWidth: _isMobile ? '80%' : 450,
            hide: showEmailScreen || showARNScreen,
            alignSelf: _isMobile && StackSelfContent.center,
            bgColor: ColorTokens.White,
            borderConfig: {
                borderColor: ColorTokens.Primary_10,
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
            },
            padding: _isMobile ? {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL,
            } : {
                left: SizeTypeTokens.Size32,
                right: SizeTypeTokens.Size32,
                top: SizeTypeTokens.Size32,
                bottom: SizeTypeTokens.Size32,
            },
            widgetItems: [
                { id: 'signupComponentContainerT1', type: WIDGET.TEXT },
                { id: 'signupComponentContainerSpace0', type: WIDGET.SPACE },
                { id: 'signupPhoneNumberstack', type: WIDGET.STACK },
                { id: 'whatsappStack', type: WIDGET.STACK },
                { id: 'spaceSM', type: WIDGET.SPACE },
                { id: 'signupComponentContainerSpace1', type: WIDGET.SPACE },
                { id: 'passwordInputStack', type: WIDGET.STACK },
                { id: 'errorSpaceStack', type: WIDGET.STACK },
                { id: "whatsappStack1", type: WIDGET.STACK },
                { id: "spaceSM", type: WIDGET.SPACE },
                { id: 'getLoginWithPasswordSpaceStack', type: WIDGET.STACK },
                { id: 'getOtpBtnStack', type: WIDGET.STACK },
                { id: 'getOtpSpacestack', type: WIDGET.STACK },
                { id: 'loginWithPasswordStack', type: WIDGET.STACK },
                { id: 'empanelStackfinal', type: WIDGET.STACK },
                { id: 'empanelSpaceStack', type: WIDGET.STACK },
                { id: 'loginWithPasswordButtonStack', type: WIDGET.STACK },
                { id: 'getLoginWithOtpSpaceStack', type: WIDGET.STACK },
                { id: 'loginWithOTPButtonStack', type: WIDGET.STACK },
                { id: 'space16', type: WIDGET.SPACE },
                {
                    id: 'tc_text',
                    type: WIDGET.TERMS_TEXT,
                },
                { id: 'signupComponentContainerSpace3', type: WIDGET.SPACE },
            ],
        },
        empanelSpaceStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "empanelSpace", type: WIDGET.SPACE }
            ]
        },
        space16: {
            size: SizeTypeTokens.XL
        },
        empanelSpace: {
            size: SizeTypeTokens.MD
        },
        spaceSM: {
            size: SizeTypeTokens.SM
        },
        errorSpaceStack: {
            hide: true,
            widgetItems: [
                { id: "spaceSM", type: WIDGET.SPACE }
            ]
        },
        getOtpSpacestack: {
            type: StackType.column,
            hide: false,
            widgetItems: [
                { id: "signupComponentContainerSpace0", type: WIDGET.SPACE }
            ]
        },
        getLoginWithPasswordSpaceStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "signupComponentContainerSpace1", type: WIDGET.SPACE }
            ]
        },
        getLoginWithOtpSpaceStack: {
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "signupComponentContainerSpace1", type: WIDGET.SPACE }
            ]
        },
        loginWithPasswordButtonStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "loginWithPasswordButton", type: WIDGET.BUTTON }
            ]
        },
        loginWithOTPButtonStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "loginWithOTPButton", type: WIDGET.BUTTON }
            ]
        },
        loginWithPasswordButton: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: 'Login',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.LOGIN_PASSWORD,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: refCode,
                    widgetId: "loginWithPasswordButton",
                },
            },
        },
        loginWithOTPButton: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: 'Login with OTP',
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.LOGIN_WITH_OTP_REDIRECT,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: '',
                    widgetId: 'loginWithOTPButton',
                    isResend: false,
                    path: path,
                },
            },
        },
        signupComponentContainerT1: {
            label: isPartnerAffiliated(partnerAccountType) ?
                `Login or Enrol as Volt Partner` :
                `Login or Empanel with Volt`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.LG,
            color: ColorTokens.Grey_Night,
        },
        signupPhoneNumberstack: {
            minWidth: !_isMobile && 384,
            width: _isMobile && StackWidth.MATCH_PARENT,
            type: StackType.column,
            widgetItems: [
                { id: "signupComponentPhoneNumber", type: WIDGET.INPUT }
            ]
        },
        signupComponentPhoneNumber: {
            onlyNumeric: true,
            isFocus: true,
            regex: RegexConfig.MOBILE,
            type: InputTypeToken.MOBILE,
            state: InputStateToken.DEFAULT,
            title: 'Mobile number *',
            charLimit: 10,
            keyboardType: KeyboardTypeToken.numberPad,
            placeholder: 'Enter mobile number',
            action: {
                type: ACTION.PHONE_NUMBER,
                payload: {
                    value: '',
                    widgetId: 'signupComponentPhoneNumber',
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
            caption: { error: 'Enter a 10 digit mobile number' },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: false,
                    targetWidgetId: 'getOtpBtn',
                },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: true,
                    targetWidgetId: 'getOtpBtn',
                },
            },
        },
        passwordInputStack: {
            minWidth: !_isMobile && 384,
            width: _isMobile && StackWidth.MATCH_PARENT,
            type: StackType.column,
            hide: true,
            widgetItems: [
                { id: "passwordInput", type: WIDGET.INPUT }
            ]
        },
        passwordInput: {
            state: InputStateToken.DEFAULT,
            title: 'Password',
            isFocus: false,
            secureTextEntry: true,
            placeholder: 'Enter password',
            action: {
                type: ACTION.GET_PASSWORD,
                payload: {
                    value: '',
                    widgetId: 'passwordInput',
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
            caption: { error: 'Enter a 10 digit mobile number' },
            errorAction: {
                type: ACTION.DISABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: false,
                    targetWidgetId: 'getOtpBtn',
                },
            },
            successAction: {
                type: ACTION.ENABLE_CONTINUE_PHONE_NUMBER,
                routeId: ROUTE.PARTNER_SIGNUP,
                payload: {
                    value: true,
                    targetWidgetId: 'getOtpBtn',
                },
            },
        },
        getOtpBtnStack: {
            minWidth: !_isMobile && 384,
            width: _isMobile && StackWidth.MATCH_PARENT,
            type: StackType.column,
            widgetItems: [{ id: "getOtpBtn", type: WIDGET.BUTTON }]
        },
        getOtpBtn: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: 'Get OTP',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.GET_OTP,
                payload: {
                    value: '',
                    widgetId: 'getOtpBtn',
                    isResend: false,
                    path: path,
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
        },
        loginWithPasswordStack: {
            minWidth: !_isMobile && 384,
            width: _isMobile && StackWidth.MATCH_PARENT,
            type: StackType.column,
            hide: false,
            widgetItems: [
                { id: "loginWithPassword", type: WIDGET.BUTTON }
            ]
        },
        loginWithPassword: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: 'Login with password',
            type: ButtonTypeTokens.LargeOutline,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.LOGIN_WITH_PASSWORD_ENTRY,
                payload: {
                    value: '',
                    widgetId: 'getOtpBtn',
                    isResend: false,
                    path: path,
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
        },
        whatsappStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                {
                    id: 'radio',
                    type: WIDGET.RADIO,
                    padding: {
                        top: 6,
                        bottom: 6,
                        left: 6,
                        right: 6,
                    },
                },
                { id: 'whatsapp_space', type: WIDGET.SPACE },
                { id: 'whatsapp', type: WIDGET.TEXT },
                { id: 'whatsapp_space', type: WIDGET.SPACE },
            ],
        },
        whatsappStack1: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            hide: true,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                {
                    id: 'radio',
                    type: WIDGET.RADIO,
                    padding: {
                        top: 6,
                        bottom: 6,
                        left: 6,
                        right: 6,
                    },
                },
                { id: 'whatsapp_space', type: WIDGET.SPACE },
                { id: 'whatsapp', type: WIDGET.TEXT },
                { id: 'whatsapp_space', type: WIDGET.SPACE },
            ],
        },
        radio: {
            color: ColorTokens.Primary_100,
            isChecked: true,
            size: IconSizeTokens.MD,
            actionChecked: {
                type: ACTION.WHATSAPP_CHECK,
                payload: {
                    value: true,
                    widgetId: 'radio',
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
            actionUnChecked: {
                type: ACTION.WHATSAPP_UNCHECK,
                payload: {
                    value: false,
                    widgetId: 'radio',
                },
                routeId: ROUTE.PARTNER_SIGNUP,
            },
        },
        whatsapp: {
            label: 'Get updates on WhatsApp',
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            fontSize: FontSizeTokens.XXS,
            color: ColorTokens.Grey_Night,
        },
        tc_text: {
            html: ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
      By proceeding, I accept <a href=${termsLink} style="text-decoration:none"><span style='color:#1434CB;'>T&Cs, </span></a> <a href=${privacyLink} style="text-decoration:none"><span style='color:#1434CB;'>Privacy Policy,</span></a> and Authorize to obtain my KYC & bureau information.
      </p>`,
            privayUrl: privacyLink,
            termsUrl: termsLink,
            privacyAction: {
                routeId: ROUTE.PARTNER_SIGNUP,
                type: ACTION.PRIVACY_POLICY,
                payload: {}
            },
            termsAction: {
                routeId: ROUTE.PARTNER_SIGNUP,
                type: ACTION.T_AND_C,
                payload: {}
            }
        },
        signupComponentContainerSpace0: {
            size: SizeTypeTokens.XXXL,
        },
        spaceXXL: {
            size: SizeTypeTokens.XXL,
        },
        signupComponentContainerSpace1: {
            size: SizeTypeTokens.XL,
        },
        spaceMD: {
            size: SizeTypeTokens.MD
        },
        signupComponentContainerSpace2: {
            size: SizeTypeTokens.MD,
        },
        signupComponentContainerSpace3: {
            size: SizeTypeTokens.MD,
        },
        whatsapp_space: { size: SizeTypeTokens.SM },
        empanelStackfinal: {
            type: StackType.column,
            hide: true,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            alignSelf: StackSelfContent.center,
            widgetItems: [
                { id: "spaceMD", type: WIDGET.SPACE },
                { id: "empanelWithUsStack", type: WIDGET.STACK },
                { id: "spaceMD", type: WIDGET.SPACE }
            ],
        },
        empanelWithUsStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: "empanelButton", type: WIDGET.TEXT },
                { id: "empanelArrow", type: WIDGET.ICON }
            ],
            action: {
                routeId: ROUTE.PARTNER_SIGNUP,
                type: ACTION.EMPANEL_US,
                payload: {
                    value: '',
                    widgetId: 'empanelWithUsStack',
                    isResend: false,
                    path: path,
                },
            }
        },
        empanelArrow: {
            name: IconTokens.RightBlueArrow,
            size: IconSizeTokens.MD
        },
        empanelButton: {
            label: 'Empanel with us',
            color: ColorTokens.Primary_100,
            textAlign: 'center',
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
        },
    };
    return DS;
};
